import http from '@/api/http';

export default {
  //机库列表
  getServerList: () => http.get('/host/manage/v1/dispatch/server_list'),
  //添加机库
  addServerList: (opts = {}) =>
    http.post('/host/manage/v1/dispatch/server_add', {
      body: {
        name: opts.name,
        qabbrev: opts.qabbrev,
      },
    }),
  //机库详情
  getServerDetail: (opts = {}) =>
    http.get('/host/manage/v1/dispatch/server_get', {
      query: {
        mid: opts.mid,
      },
    }),
  //机库详情修改
  setServerDetail: (opts = {}) =>
    http.post(`/host/manage/v1/dispatch/server_edit`, {
      body: {
        name: opts.name,
        mid: opts.mid,
      },
    }),
};
